import React from 'react';
import { createRoot, Root } from 'react-dom/client';
import App from './app';

let entryPoint: HTMLElement;
let root: Root;

const initApp = (): void => {
  root = createRoot(entryPoint);
  root.render(React.createElement(App));
};

const init = (): void => {
  entryPoint = document.querySelector('.where-to-buy-entry');

  if (entryPoint) {
    initApp();
  }
};

export default {
  init,
};
